// 需安装"vue-router"   npm install vue-router --save
import { createRouter, createWebHistory } from "vue-router";
// import { createRouter } from "vue-router";

// import Toast from "@/utils/toast";

import CivilGpt from "../pages/CivilGpt.vue";
import HelloWangHo from "../pages/HelloWangHo.vue";
import MyProject from "@/pages/MyProject.vue";
import Power_WindBase_Design from "../pages/Power_WindBase_Design.vue";
// import Power_WindBase_Draw from "../pages/Power_WindBase_Draw.vue";
import Power_SolarBracket from "../pages/Power_SolarBracket.vue";
import Power_AcDcBase from "../pages/Power_AcDcBase.vue";
import FeedBack from "../pages/FeedBack.vue";
import StructuralToolbox from "../pages/StructuralToolbox.vue";

import Material_Strength from "../pages/structyralToolbox/Material_Strength";
import Wind_Snow from "../pages/structyralToolbox/Wind_Snow";
import Seismic_Parameters from "../pages/structyralToolbox/Seismic_Parameters";
// import Toast from "@/utils/toast";
// import { wxOauth } from '@/api/index';



// name必须与controlpanel.vue中items的name一致
const Power_WindBase_Draw = () => import("../pages/Power_WindBase_Draw.vue");  // 动态导入组件
const routes = [
  {
    path: "/",
    name: "home",
    component: HelloWangHo,
  },

  {
    path: "/login",
    name: "login",
    component: () => import("../pages/Login.vue"),
  },
  {
    path: "/wxlogin",
    name: "wxLogin",
    component: () => import("../pages/wxLogin.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../pages/Register.vue"),
  },

  {
    path: "/myproject",
    name: "myProject",
    component: MyProject,
  },
  {
    path: "/civilgpt",
    name: "civilGPT",
    component: CivilGpt,
  },
  {
    path: "/feedback",
    name: "feedBack",
    component: FeedBack,
  },
  {
    path: "/cleanenergy/windbase_design",
    name: "Power_WindBase_Design",
    component: Power_WindBase_Design,
  },
  {
    path: "/cleanenergy/windbase_draw",
    name: "Power_WindBase_Draw",
    component: Power_WindBase_Draw,
  },

  {
    path: "/cleanenergy/solarbracket",
    name: "Power_SolarBracket",
    component: Power_SolarBracket,
  },
  {
    path: "/cleanenergy/acdcbase",
    name: "Power_AcDcBase",
    component: Power_AcDcBase,
  },
  {
    path: "/structuraltoolbox",
    name: "structuralToolbox",
    component: StructuralToolbox,
    children: [
      {
        path: "/material_strength",
        name: "Material_Strength",
        component: Material_Strength,
      },
      {
        path: "/wind_snow",
        name: "Wind_Snow",
        component: Wind_Snow,
      },
      {
        path: "/seismic_parameters",
        name: "Seismic_Parameters",
        component: Seismic_Parameters,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  base: '/usr/share/nginx/html/',
});

// 全局前置守卫

// router.beforeEach((to, from, next) => {
//   if (to.name === "home") {
//     next();
//   }

//   else if (to.name === "myProject" || to.name === "civilGPT") {
//     Toast('本接口仅供 SVIP 用户使用！', 'displayZone', 50, 1800, true);
//     next(false);
//   }

//   else {
//     _checkLogin()
//       .then((res) => {
//         // 1.判断是否User存在
//         if (res.data.message === 'no user') {
//           router.push({ name: "home" });
//           Toast('用户已注销，请重新注册', 'displayZone', 50, 1800, true);
//         } else {
//           // 2-1.判断是否跳转至登录页面
//           if (to.name === "login" || to.name === "register") {
//             if (res.data.code === 200) {
//               window.resizeTo(1000, 600);
//               Toast('已登录', 'displayZone', 50, 1800, true);
//               // next({ name: "home" });
//             }
//             else {
//               next();
//             }
//           }
//           // 2-2.判断是否跳转至非登录页面
//           else {
//             if (res.data.code === 200) {
//               next();
//             }
//             else {
//               Toast('请先登录', 'displayZone', 50, 1800, true);
//               next({ name: "login" });
//             }
//           }
//         }
//         // 结束
//       })
//       .catch(() => {
//         Toast('请先登录', 'displayZone', 50, 1800, true);
//         next({ name: "login" });
//       });
//   }
// });


export default router;
